import { useRouter } from "next/navigation";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { PriceSummaryHeaderSchemaType } from "@/schema/renewal-page/payment-summary-page.schema";

export function PriceSummaryHeader({
  title,
  btnHeaderLabel,
}: Readonly<PriceSummaryHeaderSchemaType>) {
  const router = useRouter();
  const { current } = useWizard();
  return (
    <div className="flex flex-col justify-center md:gap-spacing-l gap-spacing-m items-center ">
      <h1 className="text-dark-text-title text-center font-header-font md:text-5xl text-m  md:leading-[115%] leading-[120%]">
        {title}
      </h1>
      <div className="min-w-[132px]">
        <LabelButtonWrapper
          data-testid="renewal-payment-summary-header-button"
          id="renewal-payment-summary-header-button"
          isDisabled={false}
          label={btnHeaderLabel ?? "Edit renewal"}
          hierarchy="secondary"
          semanticColor="Dark Background"
          className="font-body-font py-spacing-s text-dark-text-title border-surface-neutral-option-1 !text-xs leading-[18px] font-semibold !max-h-[40px] w-full "
          type="button"
          onClick={() => {
            router.push(current.edges?.editRenewal ?? "/");
          }}
        />
      </div>
    </div>
  );
}
